import React from 'react';
import { Home } from './Pages/Home'
import { QuienesSomos } from './Pages/QuienesSomos'
import { ApoyaMali } from './Pages/ApoyaMali'
import { Obra } from './Pages/Obra'
import { AspectoLegal } from './Pages/AspectoLegal'
import Colecciones from './Pages/Colecciones'
import Coleccion from './Pages/Coleccion'
import RecursosPedagogicos from './Pages/RecursosPedagogicos'
interface iParam {
    id: string;
    value: string;
}

interface iRoute {
    title: string;
    path: string;
    content: any ;
    exact?: boolean;
    hide?: boolean;
    containParam?: boolean;
    params?: Array<iParam>;
}

interface iRoutes {
    [propName: string]: iRoute;
}

export const routes: iRoutes = {
    Home : { exact:true, path: '/', title:'Home' , content: Home },
    QuienesSomos: { exact:true, path: '/quienes-somos', title:'Quienes Somos' , content: QuienesSomos },
    AspectoLegal: { exact:true, path: '/aspecto-legal', title:'Aspecto Legal' , content: AspectoLegal },
    ApoyaMali: { exact:true, path: '/apoya-mali', title:'Apoya al MALI' , content: ApoyaMali },
    Obra: { exact:true, path: '/obra/:id', title:'Obra' , content: Obra },
    Colecciones: { exact:true, path: '/colecciones', title:'Coleccion' , content: Colecciones },
    Coleccion: { exact:true, path: '/coleccion/:col/:med', title:'Coleccion' , content: Coleccion },
    RecursosPedagogicos: { exact:true, path: '/recurospedgogicos/', title:'Recursos Pedagogicos' , content: RecursosPedagogicos },
}